import type { RouteObject } from 'react-router-dom';

/**
 * View 6, the shell's index route. `HomePage` serves the live dashboard once
 * the company is operating, and the locked dashboard before that (R2, C-1): an
 * empty state that says the dashboard activates when the SII authorises the
 * company and links to «Empezar aquí». It never redirects, so the URL stays `/`
 * and «Dashboard» stays highlighted.
 */
export const dashboardRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('../pages/HomePage').then((m) => ({
        Component: m.HomePage,
      })),
  },
];
